import { Pill } from "lucide-react"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"

interface Medication {
  id: string
  name: string
  strength?: string
  form: string
  dose: string
  route: string
  frequency: string
  duration: string
  packSize: string
  qtyOrdered: string
}

interface MedicationsListProps {
  medications: Medication[]
}

export function MedicationsList({ medications }: MedicationsListProps) {
  return (
    <Card className="rounded-xl shadow-sm border">
      <CardHeader className="pt-2 pb-6">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          <Pill className="h-4 w-4 text-teal-600 -rotate-45" />
          Medications ({medications.length})
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 pt-0">
        {medications.map((med) => (
          <Card key={med.id} className="rounded-xl shadow-sm border-0 bg-[#F0F2F5]/50">
            <CardHeader className="pb-3 pt-4 px-4">
              <div className="flex items-start justify-between">
                <div>
                  <CardTitle className="text-sm font-bold leading-tight">{med.name}</CardTitle>
                  {med.strength && (
                    <div className="text-sm text-muted-foreground mt-0.5">{med.strength}</div>
                  )}
                </div>
                <Badge variant="secondary" className="font-normal text-xs bg-white border border-gray-200 shadow-sm">
                  {med.form}
                </Badge>
              </div>
            </CardHeader>
            <CardContent className="pb-4 px-4 pt-0">
              <div className="border-t border-gray-200/60 mb-3" />
              <div className="grid grid-cols-2 gap-y-3 gap-x-4">
                <div>
                  <div className="text-xs text-muted-foreground">Dose</div>
                  <div className="text-sm font-medium">{med.dose}</div>
                </div>
                <div>
                  <div className="text-xs text-muted-foreground">Route</div>
                  <div className="text-sm font-medium">{med.route}</div>
                </div>
                <div>
                  <div className="text-xs text-muted-foreground">Frequency</div>
                  <div className="text-sm font-medium">{med.frequency}</div>
                </div>
                <div>
                  <div className="text-xs text-muted-foreground">Duration</div>
                  <div className="text-sm font-medium">{med.duration}</div>
                </div>
                <div>
                  <div className="text-xs text-muted-foreground">Pack Size</div>
                  <div className="text-sm font-medium">{med.packSize}</div>
                </div>
                <div>
                  <div className="text-xs text-muted-foreground">Qty Ordered</div>
                  <div className="text-sm font-medium text-teal-600">{med.qtyOrdered}</div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </CardContent>
    </Card>
  )
}
